import { withSearch } from '@elastic/react-search-ui';
import MultiCheckboxFilter from '../../../components/filter/MultiCheckboxFilter';

function HARHeritageCategoryFilter({
  addFilter,
  removeFilter,
  facets,
  filters,
}) {
  return (
    <MultiCheckboxFilter
      addFilter={addFilter}
      facets={facets}
      fieldId="category"
      filters={filters}
      formHint="Select all that apply."
      id="heritage-category"
      label="Heritage category"
      orderByCount={true}
      removeFilter={removeFilter}
    />
  );
}

export default withSearch(({ addFilter, removeFilter, facets, filters }) => ({
  addFilter,
  removeFilter,
  facets,
  filters,
}))(HARHeritageCategoryFilter);
